import { render, staticRenderFns } from "./recruiting.vue?vue&type=template&id=1db72dcc&scoped=true&"
import script from "./recruiting.vue?vue&type=script&lang=js&"
export * from "./recruiting.vue?vue&type=script&lang=js&"
import style0 from "./recruiting.vue?vue&type=style&index=0&id=1db72dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db72dcc",
  null
  
)

export default component.exports